import React from "react";

const PaddingBox = props => {
  return <div style={{ display: "block", height: "0px", width: "100%" }} />;
};
export default PaddingBox;
